import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { SimulationView } from '../components/Simulation';
import { ArrowLeft } from 'lucide-react';
import { useMundusStore } from '../stores/mundus.store';

export const Simulation: React.FC = () => {
  const { planId } = useParams<{ planId: string }>();
  const navigate = useNavigate();
  const { currentMundus, fetchMundusById } = useMundusStore();
  const [, setIsLoading] = useState(true);

  useEffect(() => {
    if (planId) {
      // planId could be mundusId - try to fetch mundus details
      fetchMundusById(planId).finally(() => setIsLoading(false));
    }
  }, [planId, fetchMundusById]);

  if (!planId) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-slate-900 mb-2">No Plan ID</h2>
          <p className="text-slate-600 mb-4">Please provide a plan ID to view the simulation</p>
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </button>

          <h1 className="text-3xl font-bold text-slate-900">
            {currentMundus?.name || 'Office'} Simulation
          </h1>
          <p className="text-slate-600 mt-2">
            Watch your AI agents work in real-time in a virtual office
          </p>
        </div>

        {/* Simulation View */}
        <SimulationView
          planId={planId}
          mundusId={planId}
          mundusName={currentMundus?.name}
        />
      </div>
    </div>
  );
};
